import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

//components
import { SplitButton } from "primereact/splitbutton";

import { Column } from "primereact/column";
import { TreeTable } from "primereact/treetable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TreeTableCard } from "./styled";

//utils
import { FaEllipsisH } from "react-icons/fa";
import { ActionItemLink } from "../action-item-link";

export function CoursesTable(props: any) {
	const { t: translation } = useTranslation();
	const history = useHistory();
	const {
		nodes,
		treeFields,
		handleTableSort,
		sortField,
		sortOrder,
		handleChangeStatusCourse,
		handleDeleteCourse,
		handlePublishCourse,
	} = props;

	function actionsTemplate(node: any) {
		let items: any = [];

		// Visualizar
		items.push({
			template: (
				<ActionItemLink url={`/manager/view-course/${node.data.id}`}>
					{translation("manager.links.toView")}
				</ActionItemLink>
			),
		});

		// Editar
		items.push({
			template: (
				<ActionItemLink url={`/manager/edit-course/${node.data.id}`}>
					{translation("edit")}
				</ActionItemLink>
			),
		});

		// Publicar / despublicar
		if (node.data.is_publish) {
			items.push({
				label: translation("unpublish"),
				command: () => {
					handlePublishCourse(node, "unpublish");
				},
			});
		} else if (node.data.is_active) {
			// Somente materiais ativos podem ser publicados
			items.push({
				label: translation("publish"),
				command: () => {
					handlePublishCourse(node, "publish");
				},
			});
		}

		// Ativar / inativar
		if (!node.data.is_active) {
			items.push({
				label: translation("manager.links.reactivate"),
				command: () => {
					handleChangeStatusCourse(node);
				},
			});
			items.push({
				label: translation("manager.links.remove"),
				command: () => {
					handleDeleteCourse(node);
				},
			});
		} else if (!node.data.is_publish) {
			// somente materiais despublicados podem ser inativados
			items.push({
				label: translation("manager.links.inactivate"),
				command: () => {
					handleChangeStatusCourse(node);
				},
			});
		}

		return (
			<OverlayTrigger
				placement="top"
				overlay={<Tooltip>Opções</Tooltip>}
			>
				<div>
					<SplitButton
						label=""
						className="p-button p-component p-button-rounded p-button-text p-button-icon-only"
						buttonClassName="d-none"
						dropdownIcon={<FaEllipsisH />}
						model={items}
					/>
				</div>
			</OverlayTrigger>
		);
	}

	function typeCourseTemplate(node: any) {
		return <span>{node.data.type_course_display}</span>;
	}

	function localTemplate(node: any) {
		let text = "";

		if (node.data.is_location && node.data.is_store) {
			text = "Locação, Loja";
		} else if (node.data.is_location && !node.data.is_store) {
			text = "Locação";
		} else if (!node.data.is_location && node.data.is_store) {
			text = "Loja";
		}

		return <span>{text}</span>;
	}

	function workloadTemplate(node: any) {
		let text = 0;
		if (!!node.data.workload) {
			return node.data.workload;
		}

		return text;
	}

	function rowClassName(node: any) {
		return {
			"p-inactivate": !node.data.is_active,
		};
	}

	return (
		<div>
			<TreeTableCard>
				<TreeTable
					value={nodes}
					rowClassName={rowClassName}
					sortField={sortField}
					sortOrder={sortOrder}
					onSort={(e) => handleTableSort(e)}
				>
					{!!treeFields?.length &&
						treeFields?.map((col: any) => {
							if (col.actionsTemplate) {
								return (
									<Column
										key={col.field}
										body={actionsTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else if (col.localTemplate) {
								return (
									<Column
										key={col.field}
										body={localTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else if (col.typeCourseTemplate) {
								return (
									<Column
										key={col.field}
										body={typeCourseTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else if (col.workloadTemplate) {
								return (
									<Column
										key={col.field}
										body={workloadTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else {
								return (
									<Column
										key={col.field}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							}
						})}
				</TreeTable>
			</TreeTableCard>
		</div>
	);
}
